/**
 * 颜色转rgb，调低透明度为0.1
 * @param hexColor hex色值
 * @returns rgba(色值, 色值,色值,透明度)
 */
export function hexToRgba(hexColor, opacity = 0.1) {
    if (!hexColor)
        return '';
    const red = parseInt(hexColor.slice(1, 3), 16);
    const green = parseInt(hexColor.slice(3, 5), 16);
    const blue = parseInt(hexColor.slice(5, 7), 16);
    // 将转换后的值组合成 RGBA 值
    return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
